import { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useMasterData } from '../context/MasterDataContext';

export default function ProtectedRoute({ children }) {
  const token = localStorage.getItem('token');
  const location = useLocation();
  const { isLoaded, isLoadingMasterData, refreshMasterData } = useMasterData() || {};

  useEffect(() => {
    if (token && !isLoaded && !isLoadingMasterData && refreshMasterData) {
      refreshMasterData(token);
    }
  }, [token, isLoaded, isLoadingMasterData, refreshMasterData]);

  if (!token) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
}
